module.exports = __webpack_public_path__ + "img/qr-main.22d2a833.png";